import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AppService {
  /**
   * Sorts dates
   * @param dates
   * @returns dates
   */
  sortDates(dates) {
    dates.sort(function (firstDate, secondDate) {
      if (firstDate.date < secondDate.date) {
        // sort dates in accending order
        return -1;
      }
      if (firstDate.date > secondDate.date) {
        return 1;
      }

      return 0; // default return value (no sorting)
    });

    return dates;
  }
}
